const operationPackageEn = {
  addPattern: {
    addButtonLabel: 'Add operation package pattern',
    error: 'Failed to create operation package pattern',
    success: 'Operation package pattern created successfully',
  },
  addPersonDialog: {
    contractFrom: 'Start date',
    contractFromRequired: 'Please select a start date',
    description: 'Create a new person',
    emailRequired: 'Either a work email or personal email address is required.',
    infoMessage: 'An account creation invitation email will be sent.',
    inviteEmailTargetLabel:
      'Invitation email destinations (select at least one)',
    inviteEmailTargetPersonal: 'Personal email ({{email}})',
    inviteEmailTargetWork: 'Work email ({{email}})',
    inviteTargetsRequired: 'Select at least one invitation destination.',
    personalEmail: 'Personal email',
    title: 'Create new',
  },
  sideBar: {
    close: 'Close side tab',
  },
  tableEmpty: {
    notFound: 'No results found',
  },
};

export default operationPackageEn;
